import type { Page } from '@inertiajs/core'
import type { PageProps } from '@/types'
import { usePage as inertiaUsePage } from '@inertiajs/vue3'

export function usePage<SharedProps>(): Page<SharedProps & PageProps> {
  return inertiaUsePage<SharedProps & PageProps>()
}
